import { cn } from '@/lib/utils';

const ColumnsTest = () => (
  <main
    className={cn(
      'min-h-[100vh]',
      'flex justify-between [&>*]:shrink-1',
      '2xl:bg-green-200',
      'xl:bg-green-100',
      'lg:bg-blue-100',
      'md:bg-yellow-100',
      'sm:bg-red-100',
      'bg-purple-100',
    )}
  >
    <div className={cn('flex', /* "px-0 py-2 sm:px-2", */ 'group/stack')}>
      <div
        className={cn(
          'min-h-full w-sm',
          'rounded-2xl border border-black bg-gray-500',
        )}
      >
        panel
      </div>
      <div
        className={cn(
          'min-h-full w-lg',
          'rounded-2xl border border-black bg-gray-500',
        )}
      >
        panel
      </div>
    </div>
    <div className={cn('flex', /* "px-0 py-2 sm:px-2", */ 'group/stack')}>
      <div
        className={cn(
          'min-h-full w-sm',
          'rounded-2xl border border-black bg-gray-500',
        )}
      >
        panel
      </div>
    </div>
  </main>
);

export default ColumnsTest;
